<template>
  <div class="container pt-mb-5 pt-3 mb-sm-5 mb-3">
    <div class="dashboard">
      <div class="row mt-5">
        <div class="col-lg-3 col-md-4 mb-5">
          <div class="sidebar">
            <a href="#"><h3 class="ser-vis-head dasssh">Dashboard</h3></a>
            <ul>
              <li>
                <a :href="myProfileRoute" class="hover-color"> <img :src="props.image1" class="iamgdd1" />User Profile</a>
              </li>
              <li >
                <a :href="props.addPet" class=" hover-color"> <img :src="props.image2" class="iamgdd1" /> Pets</a>
              </li>
              <li>
                <a :href="props.myBookings" class="hover-color"> <img :src="props.image3" class="iamgdd1" />My Bookings</a>
              </li>
               <li class="prof-2">
                <a :href="props.myReward" class="my_reward hover-color"> <img :src="props.image3" class="iamgdd1" />My Rewards</a>
              </li>
              <li>
                <a :href="props.logoutRoute" class="hover-color"> <img :src="props.image4" class="iamgdd1" />Logout</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-9 col-md-8 mb-5">
          <div class="my-pet-head">
            <h5>My Rewards</h5>
            <button class="btn btn-primary add-new-btns" >{{props.rewardPoints}}</button>
          </div>
          <div class="main-content">
             
            <table class="table table_resposive">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Description</th>
                  <th scope="col">Points</th>
                  <th scope="col">Date</th> 
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rewardDetails, index) in rewardHistory" :key="rewardDetails.id">
                  <th scope="row" class="middle">{{ index + 1 }}</th>
                  <td>{{ rewardDetails.description }}</td>
                  <td>{{ rewardDetails.points }}</td>
                  <td>{{ rewardDetails.createdAt }}</td>  
                  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="spring-img">
    <img :src="props.image1" />
  </div>

  <div class="spring-img-2">
    <img :src="props.image2" />
  </div> -->
</template>
<script setup>
import { ref } from 'vue'
import axios from 'axios'
import * as yup from 'yup'
import { useField, useForm } from 'vee-validate'
import InputField from '@/vue/components/form-elements/InputField.vue'

const errorMessages = ref({})
const props = defineProps({
  rewardHistory: Array,
  rewardPoints: String,  
  myBookings: String,
  myReward: String,
  breeds: String,
  myProfileRoute: String,
  image1: String,
  image2: String,
  image3: String,
  image4: String,
  image5: String,
  image6: String
})
 
 
  
 
  
</script>

<style scoped>
/* .dashboard {
  display: flex;
  margin: 0 auto;
} */

.sidebar {
  max-width: 100%;
  padding: 20px;
  top: 48px;
  border-radius: 10px;
  position: static;
  box-shadow: none !important;
  background: #f8f8f8;
}

.sidebar h2 {
  margin-bottom: 20px;
}

.sidebar ul {
  list-style: none;
  padding: 0;
}

.sidebar ul li {
  margin-bottom: 10px;
  padding: 10px 15px;
}

.sidebar ul li a {
  text-decoration: none;
  color: #2e2928;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
}

/* .sidebar ul li a:hover {
  color: #bf360c;
} */

.main-content {
  flex: 1;
  /* padding: 20px; */
  margin-left: 0px !important;
  border-radius: 10px;
  /* margin-top: 40px; */
  background-color: white;
  border: 1px solid #ececec;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
}

.table-head tr td {
  padding: 1rem 1.5rem;
  white-space: nowrap;
}

.table tbody tr td {
  border-bottom: 1px dashed #ececec !important;
}
.middle {
  border-bottom: 1px dashed #ececec !important;
}

.stats {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  padding: 10px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
}

.order-list {
  list-style: none;
  padding: 0;
}

.order-list li {
  margin-bottom: 5px;
  border: 1px solid #ddd;
  padding: 5px;
  display: flex;
  justify-content: space-between;
}
.clos-btn {
  color: #000;
  background-color: #ffff !important;
  border-radius: 10px;
}

.add-new-btns {
  color: black;
  background: transparent;
}
.add-new-btns:hover {
  color: white;
  background-color: #bf360c;
}
.web-bg {
  background-color: #fbfbfb;
}

.middle {
  vertical-align: middle;
}

.edit-icon {
  display: flex;
}

.edit-icon i {
  cursor: pointer;
}

/* .edit-icon i:hover {
  color: #bf360c;
} */

.my-pet-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
  /* border-bottom: 1px dashed #bf360c; */
  /* padding-bottom: 20px; */
}

.my-pet-head h5 {
  font-size: 20px;
  font-weight: 600;
  color: #2e2928;
}
.sidebar ul li a.active {
  color: #bf360c !important;
}
.my_pets {
  color: #bf360c !important;
}

.web-bg {
  position: relative;
}

.spring-img {
  position: absolute;
  bottom: 20px;
  left: -40px;
}

.spring-img img {
  width: 150px;
}

.spring-img-2 img {
  width: 130px;
}

.spring-img-2 {
  position: absolute;
  top: 30px;
  right: 0;
}

.iamgdd1 {
  width: 30px;
  margin-right: 10px;
}

.sidebar ul li:hover {
  background-color: #f9ede8;
  border-radius: 20px;
}

.prof-2 {
  background-color: #f9ede8 !important;
  border-radius: 20px;
  margin-bottom: 10px;
}
.sidebar ul li:hover .hover-color {
  color: #bf360c !important;
}

.table_resposive {
  border-radius: 10px 10px 0px 0px;
}

/* #addNewPet .contact-page-form label {
    margin-bottom: 10px;
    color: #2e2928;
    font-weight: 550;
  } */

/* .contact-page-form label {
  font-weight: 550 !important;
} */

.model-shadow {
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px !important;
  border: none !important;
  border-radius: 15px;
  padding: 20px;
}

.iamgd2 {
  width: 20px;
  margin-left: 10px;
}

label {
  color: #000;
}

@media screen and (max-width: 1600px) {
  .spring-img-2 img {
    display: none;
  }
  .spring-img img {
    display: none;
  }
}

@media screen and (max-width: 1199px) {
  /* .sidebar {
    height: 250px;
  } */
}

@media screen and (max-width: 991px) {
  .table_resposive {
    display: block;
    width: 100%;
    overflow-x: auto;
  }
}

@media screen and (max-width: 767px) {
  .web-bg .sidebar {
    height: auto !important;
  }
  .web-bg .main-content {
    margin-top: 20px;
  }
}
</style>
